import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    actionUrl: 'https://www.paypal.com/cgi-bin/webscr',
    payment_button_id: 'D76NYXNK5W7JY'
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
